import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 11l1 -9l5 .5l-1 13.5l-3 6l-12.5 -2.5l-1.5 -6l7 -1.5l-1.5 -7.5l4.5 -1l2 7.5","key":"svg-0"}],["path",{"d":"M14.5 15.5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","fill":"currentColor","key":"svg-1"}],["path",{"d":"M10.5 14.5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","fill":"currentColor","key":"svg-2"}]]

const IconBrandDeliveroo = createReactComponent('outline', 'brand-deliveroo', 'BrandDeliveroo', __iconNode);

export default IconBrandDeliveroo;